/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { Dashicon } from '@wordpress/components';

import './style.scss';

class Label extends React.Component {
	static propTypes = {
		title: PropTypes.string,
		children: PropTypes.element.isRequired,
		className: PropTypes.string,
		description: PropTypes.string,
		panel: PropTypes.bool,
		collapsible: PropTypes.bool,
	};

	static defaultProps = {
		title: null,
		className: null,
		description: null,
		panel: false,
		collapsible: false,
	};

	state = {
		isOpen: false,
	};

	toggleCollapse = () => {
		const { collapsible } = this.props;
		if (collapsible) {
			this.setState(state => ({ isOpen: !state.isOpen }));
		}
	};

	render() {
		const {
			title,
			children,
			description,
			className,
			panel,
			collapsible,
		} = this.props;
		const { isOpen } = this.state;
		const id = uuid();
		const classes = classNames('eform-gtb-label', className, {
			'eform-gtb-label--panel': panel,
			'eform-gtb-label--collapsible': collapsible,
			'eform-gtb-label--open': isOpen,
		});
		return (
			<div className={classes}>
				{title !== null ? (
					<label
						onClick={this.toggleCollapse}
						className="eform-gtb-label__label"
						htmlFor={id}
					>
						<span className="eform-gtb-label__title">{title}</span>
						{collapsible ? (
							<span className="eform-gtb-label__collapsible">
								<Dashicon
									icon={
										isOpen
											? 'arrow-up-alt2'
											: 'arrow-down-alt2'
									}
								/>
							</span>
						) : null}
					</label>
				) : null}
				{isOpen || !collapsible ? (
					<div className="eform-gtb-label__control">
						{React.cloneElement(children, { id })}
					</div>
				) : null}
				{description ? (
					<div className="eform-gtb-label__description">
						<p className="description">{description}</p>
					</div>
				) : null}
			</div>
		);
	}
}

export default Label;
